import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { TransferFundsRequest } from '@cash-web/shared-util-protos/squareup/franklin/TransferFundsRequestProto.pb'
import { TransferFundsResponse } from '@cash-web/shared-util-protos/squareup/franklin/TransferFundsResponseProto.pb'

export const transferFunds = (request: TransferFundsRequest, options?: CashRequestOptions) =>
  post<TransferFundsRequest, TransferFundsResponse>('/2.0/cash/transfer-funds', request, {
    ...options,
    rejectOnError: true,
  })
